export default __webpack_public_path__ + "static/media/arco-ameaca.33fdef92.webp";